import burger from "../img/portImages/ezgif.com-gif-maker (1).gif";
import rockPaperScissors from "../img/portImages/rockPaper.gif";
import searchUsersGitHub from "../img/portImages/Search-Users-GitHub-REST-API-gif.gif";
import taskManager from "../img/portImages/Task-Manager (1).gif";
import node from "../img/portImages/node2.jpeg";
import aspNet from "../img/portImages/asp-net-and-sql-developer-salary.png";
import chatApp from "../img/portImages/chatApp.gif";
import covid19 from "../img/portImages/covid19.gif";
import youtubeMp3Mp4 from "../img/portImages/youtubeMp3-Mp4.gif";
import employeeManagement from "../img/portImages/employeeManagement.gif";
import myMovies from "../img/portImages/myMovies.gif";
import myPort from "../img/portImages/my-port.gif";
import breakout from "../img/portImages/breakout.png";
import ahsen from "../img/portImages/ahsen.png";
import salevali from "../img/portImages/salevali.png";
import home from "../img/portImages/home.png";
import mementooo from "../img/portImages/mementooo.png";

const projects = [
  {
    id: 1,
    category: "Vanilla JS",
    link1: "https://github.com/bomercakmak/rock-paper-scissors-game",
    link2: "https://bomercakmakgame.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: rockPaperScissors,
    title: "Rock Paper Scissors Game",
    info: "HTML5, CSS3, JavaScript",
  },
  {
    id: 2,
    category: "Vanilla JS",
    link1: "https://github.com/bomercakmak/Search-Users-GitHub-REST-API",
    link2: "https://bomercakmak.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: searchUsersGitHub,
    title: "Search GitHub Users",
    info: "HTML5, CSS3, JavaScript, Web Storage API, GitHub REST API",
  },
  {
    id: 3,
    category: "React JS",
    link1: "https://github.com/bomercakmak/task-manager-react",
    link2: "https://static-task-manager-react.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: taskManager,
    title: "Task Manager React JS",
    info: "HTML5, CSS3, JavaScript, JSON Server REST API, React JS",
  },
  {
    id: 4,
    category: "React JS",
    link1: "https://github.com/bomercakmak/my-movies-react",
    link2: "",
    icon1: "SOURCE \n CODE",
    icon2: "",
    image: myMovies,
    title: "My Movies React JS",
    info: "HTML5, CSS3, Bootstrap, JavaScript, JSON Server REST API, React JS, React Router,",
  },
  {
    id: 6,
    category: "ASP.NET",
    link1: "https://github.com/bomercakmak/food-recipes-ASP.NET",
    link2: "",
    icon1: "SOURCE \n CODE",
    icon2: "",
    image: aspNet,
    title: "Food Recipes Website ASP.NET",
    info: "HTML5, CSS3, C#, ASP.NET, Microsoft SQL Server",
  },
  {
    id: 5,
    category: "React JS",
    link1: "https://github.com/bomercakmak/employee-management-system-react",
    link2: "https://bomercakmak-employee-management-system.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: employeeManagement,
    title: "Employee Management System React JS",
    info: "HTML5, CSS3, JavaScript, Web Storage API, React JS",
  },
  {
    id: 7,
    category: "React JS",
    link1:
      "https://github.com/bomercakmak/youtube-mp4-mp3-downloader-converter-react",
    link2: "https://bomercakmak-youtube-mp3-mp4-downloader.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: youtubeMp3Mp4,
    title: "Youtube MP4/MP3 Downloader Converter React JS",
    info: "HTML5, CSS3, JavaScript, React JS",
  },
  {
    id: 8,
    category: "Express JS",
    link1: "https://github.com/bomercakmak/SO-Question-Answer-Rest-Api",
    link2: "",
    icon1: "SOURCE \n CODE",
    icon2: "",
    image: node,
    title: "Stack Overflow Question Answer Backend Clone",
    info: "JavaScript, Node.js, Express, MongoDB, Mongoose, JWT, Multer, Nodemailer",
  },
  {
    id: 9,
    category: "React JS",
    link1: "https://github.com/bomercakmak/chat-application-react",
    link2: "https://bomercakmak-chat-app.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: chatApp,
    title: "Chat Application React JS",
    info: "HTML5, CSS3, JavaScript, Web Storage API, Chat Engine, React JS",
  },
  {
    id: 10,
    category: "React JS",
    link1: "https://github.com/bomercakmak/burger-builder-react",
    link2: "https://bomercakmak-burger-builder.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: burger,
    title: "Burger Builder React JS",
    info: "HTML5, CSS3, JavaScript, Web Storage API, React JS, React Router, Redux, Firebase",
  },
  {
    id: 11,
    category: "React JS",
    link1: "https://github.com/bomercakmak/covid-19-tracker-react",
    link2: "https://bomercakmak-covid-19-tracker.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: covid19,
    title: "COVID-19 Tracker React JS",
    info: "HTML5, CSS3, JavaScript, React JS, Charts.js, Material UI",
  },
  {
    id: 12,
    category: "React JS",
    link1: "https://github.com/bomercakmak/my-portfolio-react",
    link2: "https://cakmak.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: myPort,
    title: "My Portfolio React JS",
    info: "HTML5, SCSS, JavaScript, React JS, React Bootstrap, React Router",
  },
  {
    id: 13,
    category: "React JS",
    link1: "https://github.com/bomercakmak/breakout-game-react",
    link2: "https://cakmak-49897-project-multimedia.netlify.app/",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: breakout,
    title: "Breakout Game React JS",
    info: "HTML5, CSS, Canvas, JavaScript, React JS",
  },
  {
    id: 14,
    category: "React JS",
    link1: "",
    link2: "https://ahsenonline.com/",
    icon1: "",
    icon2: "LIVE \n WEBSITE",
    image: ahsen,
    title: "Ahsen (OMS) React JS",
    info: "HTML5, CSS, Canvas, JavaScript, React JS, Redux Toolkit, Firebase",
  },
  {
    id: 15,
    category: "React JS",
    link1: "",
    link2: "https://www.salevali.de/",
    icon1: "",
    icon2: "LIVE \n WEBSITE",
    image: salevali,
    title: "SaleVali React JS",
    info: "HTML5, CSS, JavaScript, React JS, Redux-Saga, Formik, Node.js, LoopBack, MangoDB, Scrum",
  },
  {
    id: 16,
    category: "React JS",
    link1: "https://github.com/bomercakmak/UniSocial-Thesis-Project",
    link2: "https://unisocial.netlify.app",
    icon1: "SOURCE \n CODE",
    icon2: "LIVE \n WEBSITE",
    image: home,
    title: "UniSocial React JS",
    info: "HTML5, CSS, Material-UI, JavaScript, React JS, Redux-Saga, Firebase",
  },
  {
    id: 17,
    category: "MERN Stack",
    link1: "https://github.com/bomercakmak/Memento-MERN-Stack-Social-Media",
    link2: "",
    icon1: "SOURCE \n CODE",
    icon2: "",
    image: mementooo,
    title: "Memento MERN Stack Social Media",
    info: "HTML5, CSS, Material-UI, JavaScript, React JS, Redux, Node.js, Express, MongoDB, Mongoose",
  },
];

export default projects;
